/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridColumnGroupOptions } from './igr-grid-column-group-options';
import { GridColumnGroupOptions } from './GridColumnGroupOptions';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridColumnGroupOptionsModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridColumnGroupOptionsModule() {
    }
    IgrGridColumnGroupOptionsModule.register = function () {
        TypeRegistrar.registerCons('IgrGridColumnGroupOptions', IgrGridColumnGroupOptions);
        TypeRegistrar.registerCons('IgrGridColumnGroupOptions', IgrGridColumnGroupOptions);
        TypeRegistrar.register('GridColumnGroupOptions', GridColumnGroupOptions.$type);
    };
    return IgrGridColumnGroupOptionsModule;
}());
export { IgrGridColumnGroupOptionsModule };
//# sourceMappingURL=igr-grid-column-group-options-module.js.map
